import React, { useState } from 'react'
import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboard, faCheck } from '@fortawesome/free-solid-svg-icons'
import { toast, Flip } from 'react-toastify'
import { calculatePercent } from 'helpers/utils'
import MutedText from 'shared/forms/muted-text'

function DescriptionCard({ conflict }) {
  const [active, setActive] = useState(false)
  const [isCopied, setIsCopied] = useState(false)

  const copiedAlert = (message) => {
    setIsCopied(true)
    toast.info(`Copied ${message} to clipboard`, {
      position: 'top-center',
      autoClose: 1000,
      transition: Flip,
      hideProgressBar: true,
      progress: undefined,
      theme: 'light'
    })
  }

  return (
    <>
      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Row>
                <Col>
                  <div>
                    <h5>Users</h5>
                    <Card.Text className="text-muted">
                      {conflict.employees_count}
                      <span className="text-muted float-end fw-light text-sm">
                        {calculatePercent(
                          conflict.employees_count,
                          conflict.total_employees_count
                        )}
                        %
                      </span>
                    </Card.Text>
                  </div>
                </Col>
                <Col>
                  <div>
                    <h5>Roles</h5>
                    <Card.Text className="text-muted">
                      {conflict.roles_count}
                      <span className="text-muted float-end fw-light text-sm">
                        {calculatePercent(
                          conflict.roles_count,
                          conflict.total_roles_count
                        )}
                        %
                      </span>
                    </Card.Text>
                  </div>
                </Col>
                {conflict.permission_variable && (
                  <Col>
                    <div>
                      <h5>{conflict.permission_variable.name}</h5>
                      <Card.Text className="text-muted">
                        {conflict.permission_variable.permissions.length}{' '}
                        Permissions
                      </Card.Text>
                    </div>
                  </Col>
                )}
                {conflict.conflicting_variable && (
                  <Col>
                    <div>
                      <h5>{conflict.conflicting_variable.name}</h5>
                      <Card.Text className="text-muted">
                        {conflict.conflicting_variable.permissions.length}{' '}
                        Permissions
                      </Card.Text>
                    </div>
                  </Col>
                )}
              </Row>
              <Row className="mt-4">
                <Col>
                  <span className="fw-bold">Functional Area</span>
                  <div className="fw-light mt-2">
                    {conflict.functional_area}
                  </div>
                </Col>
              </Row>
              <div
                onClick={() => {
                  navigator.clipboard.writeText(conflict.description)
                  copiedAlert('analytic description')
                }}
                className={
                  active ? 'mt-4 bg-light rounded text-primary' : 'mt-4'
                }
                style={{ cursor: 'pointer' }}
                onMouseEnter={() => setActive(true)}
                onMouseLeave={() => setActive(false)}
              >
                <div className="fw-bold">
                  Description
                  {isCopied && (
                    <small className="text-success fw-lighter">
                      <FontAwesomeIcon icon={faCheck} className="ms-1" /> Copied
                    </small>
                  )}
                  {!isCopied && active && (
                    <MutedText as="small" lighter>
                      <FontAwesomeIcon icon={faClipboard} className="ms-1" />{' '}
                      Copy
                    </MutedText>
                  )}
                </div>
                <div className="fw-light mt-2">{conflict.description}</div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default DescriptionCard
